import { widgetSupportsUrlLeadSources, } from 'hx-analytics/src/constants/url-lead-source.constant';
export function doesWidgetSupportUrlLeadSource(widgetName) {
    return widgetSupportsUrlLeadSources.includes(widgetName);
}
